// src/components/DonateButtons.jsx
import React from 'react';
import './DonateButtons.css';  // Import the CSS file for styling

const DonateButtons = () => {
  return (
    <div className="donate-container">
      <h1>Donate to Tampa Zakah Fund</h1>

      <button 
        className="donate-button primary-button"
        onClick={() => {
          window.open('https://www.zeffy.com/en-US/donation-form/tampa-zakah-fundzakah-funds-only', '_blank');
        }}
      >
        Pay your Zakah
      </button>  

      <button 
        className="donate-button primary-button"
        onClick={() => window.open('https://www.zeffy.com/en-US/donation-form/tampa-zakah-fundsadaqa-funds-only', '_blank')}
      >
        Donate to Sadaqa Funds
      </button>

    </div>
  );
};

export default DonateButtons;
